import { createFileRoute } from "@tanstack/react-router";
import TmsOcd from "@/pages/TmsOcd";
export const Route = createFileRoute("/services/ocd")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS for OCD | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "OCD treatment in Coral Springs, FL. Medication management, therapy, and TMS for obsessive-compulsive disorder at Neuro Wellness TMS. Free consultation.",
        },
        {
          property: "og:title",
          content: "TMS for OCD | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "OCD treatment in Coral Springs, FL. Medication management, therapy, and TMS for obsessive-compulsive disorder at Neuro Wellness TMS. Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/ocd",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/ocd",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsOcd />;
}
